// extracted by mini-css-extract-plugin
export default {"title":"zSlQ7w","holder":"m_BSz0","description":"xWgNd3","button":"T5N2vr"};